export const COLLECTIONS_ROUTE = '/collections';
export const COLLECTIONS_ID_PARAM = '/:collectionId';
